import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { mergeRefs } from '@lumapps/utils/react/mergeRefs';
import { useFocused, useSelected, useSlate, type ReactEditor } from '@lumapps/wrex/slate';
import { useInlineVoid } from '@lumapps/wrex/slate/utils/useInlineVoid';
import type { ElementRender } from '@lumapps/wrex/types';

import { COLUMNS } from '../../../constants';
import type { ColumnsEditor, ColumnsElement } from '../../../types';
import { Columns } from '../../blocks/Columns';
import { ColumnsToolbar } from '../../blocks/ColumnsToolbar';

import './index.scss';

const CLASSNAME = 'wrex-content-columns';

/**
 * Display a columns wrapper
 */
export const EditableColumns: ElementRender<ColumnsElement, HTMLDivElement> = (props) => {
    const { elementRef, children, element = {} as ColumnsElement, ...forwardedProps } = props;
    const { block } = useClassnames(CLASSNAME);
    const editor = useSlate() as ReactEditor & ColumnsEditor;
    const { onDelete } = useInlineVoid(editor, element);
    const isFocused = useFocused();
    const isSelected = useSelected();
    const selected = isSelected && isFocused;
    const ref = React.useRef(null);

    return (
        <Columns
            {...forwardedProps}
            className={block({ editable: true, selected })}
            element={element}
            elementRef={mergeRefs([elementRef, ref])}
        >
            <ColumnsToolbar anchorRef={ref} isOpen={selected} onDelete={onDelete} />
            {children}
        </Columns>
    );
};

EditableColumns.displayName = COLUMNS;
